import AnimationRevealPage from "helpers/AnimationRevealPage";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import LineChart from "components/charts/LineChart";
import BarChart from "components/charts/BarChart";
import demographicsShortage from "../data/demographicShortage.json";
import employedSwitzerland from "../data/employedSwitzerland.json";
import trendEmployeesSwitzerland from "../data/trendEmployeesSwitzerland.json";
import trendNeedEmployees from "../data/trendNeedEmployees.json";
import trendAvailabilityEmployees from "../data/trendAvailabilityEmployees.json";
import cumulativeDemographic from "../data/cumulativeDemographic.json";
import netImmigrationCh from "../data/netImmigrationCh.json";
import netImmigrationPT from "../data/netImmigrationPT.json";
import netImmigrationDE from "../data/netImmigrationDE.json";
import netImmigrationFR from "../data/netImmigrationFR.json";
import netImmigrationIT from "../data/netImmigrationIT.json";
import fulltimeJobsCH from "../data/fulltimeJobsCH.json";
import fulltimeJobsCHIndustrial from "../data/fulltimeJobsCHIndustrial.json";
import fulltimeJobsCHService from "../data/fulltimeJobsCHService.json";
import watchIndustry from "../data/watchIndustry.json";
import memIndustrial from "../data/memIndustrial.json";
import retail from "../data/retail.json";
import healthcare from "../data/healthcare.json";
import ict from "../data/ict.json";
import watchIndustryArea from "../data/watchIndustryArea.json";
import memIndustrial2 from "../data/memIndustrial2.json";
import retailArea from "../data/retailArea.json";
import healthcareArea from "../data/healthcareArea.json";
import ict2 from "../data/ict2.json";
import projectManagement from "../data/projectManagement.json";
import projectManagementStrategic from "../data/projectManagementStrategic.json";
import personalDevelopment from "../data/personalDevelopment.json";
import mechanic from "../data/mechanic.json";
import applicationDevelopment from "../data/applicationDevelopment.json";
import ictSysteme from "../data/ictSysteme.json";
import ictNetwork from "../data/ictNetwork.json";
import nursing from "../data/nursing.json";
import purchasing from "../data/purchasing.json";
import processOptimizationLogistic from "../data/processOptimizationLogistic.json";
import processOptimizationICT from "../data/processOptimizationICT.json";






const demographicsShortageData = {
    label: "",
    data: demographicsShortage,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const employedSwitzerlandData = {
    label: "Employed Switzerland",
    data: employedSwitzerland,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const trendEmployeesSwitzerlandData = {
    label: "Trend employees Switzerland",
    data: trendEmployeesSwitzerland,
    borderColor: 'rgb(182, 3, 252)',
    backgroundColor: 'rgba(182, 3, 252, 0.5)',
    borderDash: [10,5]
}

const trendNeedEmployeesData = {
    label: "Trend need employees",
    data: trendNeedEmployees,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const trendAvailabilityEmployeesData = {
    label: "Trend availability employees",
    data: trendAvailabilityEmployees,
    borderColor: 'rgb(182, 3, 252)',
    backgroundColor: 'rgba(182, 3, 252, 0.5)',
    borderDash: [10,5]
}

const cumulativeDemographicData = {
    label: "",
    data: cumulativeDemographic,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}


const netImmigrationChData = {
    label: "Switzerland",
    data: netImmigrationCh,
    backgroundColor: 'rgb(3, 194, 252)'
}

const netImmigrationPTData = {
    label: "Portugal",
    data: netImmigrationPT,
    backgroundColor: 'rgb(3, 107, 252)'
}

const netImmigrationDEData = {
    label: "Germany",
    data: netImmigrationDE,
    backgroundColor: 'rgb(67, 191, 104)'
}

const netImmigrationFRData = {
    label: "France",
    data: netImmigrationFR,
    backgroundColor: 'rgb(163, 212, 178)'
}

const netImmigrationITData = {
    label: "Italy",
    data: netImmigrationIT,
    backgroundColor: 'rgb(214, 217, 41)'
}

const fulltimeJobsCHData = {
    label: "",
    data: fulltimeJobsCH,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const fulltimeJobsCHIndustrialData = {
    label: "",
    data: fulltimeJobsCHIndustrial,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const fulltimeJobsCHServiceData = {
    label: "",
    data: fulltimeJobsCHService,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}


const watchIndustryData = {
    label: "",
    data: watchIndustry,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}


const memIndustrialData = {
    label: "",
    data: memIndustrial,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const retailData = {
    label: "",
    data: retail,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const healthcareData = {
    label: "",
    data: healthcare,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const ictData = {
    label: "",
    data: ict,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}


const watchIndustryAreaData = {
    label: "",
    data: watchIndustryArea,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const memIndustrial2Data = {
    label: "",
    data: memIndustrial2,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const retailAreaData = {
    label: "",
    data: retailArea,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const healthcareAreaData = {
    label: "",
    data: healthcareArea,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const ict2Data = {
    label: "",
    data: ict2,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const projectManagementData = {
    label: "",
    data: projectManagement,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const projectManagementStrategicData = {
    label: "",
    data: projectManagementStrategic,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const personalDevelopmentData = {
    label: "",
    data: personalDevelopment,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const mechanicData = {
    label: "",
    data: mechanic,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const applicationDevelopmentData = {
    label: "",
    data: applicationDevelopment,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const ictSystemeData = {
    label: "",
    data: ictSysteme,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const ictNetworkData = {
    label: "",
    data: ictNetwork,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const nursingData = {
    label: "",
    data: nursing,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const purchasingData = {
    label: "",
    data: purchasing,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const processOptimizationLogisticData = {
    label: "",
    data: processOptimizationLogistic,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const processOptimizationICTData = {
    label: "",
    data: processOptimizationICT,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}




function OurAnalyses({ headingText = "Terms And Condition" }) {
    return (
        <AnimationRevealPage>
            <Header />
            <Container>
                <ContentWithPaddingXl>
                    <LineChart 
                        data={[demographicsShortageData]}
                        title="Demographic shortage CH 2015-2035 %"
                        legend={false}
                        yLabel="%"
                    />
                    <LineChart 
                        data={[employedSwitzerlandData, trendEmployeesSwitzerlandData]}
                        title="Developement of employees in Switzerland 2015 - 2020"
                    />
                    <LineChart 
                        data={[trendNeedEmployeesData, trendAvailabilityEmployeesData]}
                        title="Employment trend in Switzerland 2020 - 2035"
                    />
                    <LineChart 
                        data={[cumulativeDemographicData]}
                        title="Cumulative demographic deficit D-A-CH"
                        legend={false}
                    />
                    <BarChart 
                        data={[netImmigrationChData, netImmigrationPTData, netImmigrationDEData, netImmigrationFRData, netImmigrationITData]}
                        title="Net immigration to Switzeland"
                    />
                    <LineChart 
                        data={[fulltimeJobsCHData]}
                        title="Full-time jobs CH Total"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart 
                        data={[fulltimeJobsCHIndustrialData]}
                        title="Full-time positions in the CH industrial sector"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart 
                        data={[fulltimeJobsCHServiceData]}
                        title="Employment statistics CH service sector"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart 
                        data={[watchIndustryData]}
                        title="Watch industry"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart 
                        data={[memIndustrialData]}
                        title="MEM-industrial"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart 
                        data={[retailData]}
                        title="Retail trade"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart 
                        data={[healthcareData]}
                        title="Healthcare"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart 
                        data={[ictData]}
                        title="ICT"
                        legend={false}
                        xLabel=" - III"
                    />
                    <LineChart 
                        data={[watchIndustryAreaData]}
                        title="Watch industry area"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[memIndustrial2Data]}
                        title="MEM-industrial"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[retailAreaData]}
                        title="Retail area"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[healthcareAreaData]}
                        title="Healthcare area"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[ict2Data]}
                        title="ICT (Information & Communication Technologies)"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[projectManagementData]}
                        title="Project management"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[projectManagementStrategicData]}
                        title="Project management for strategic development"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[personalDevelopmentData]}
                        title="Personal development"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[mechanicData]}
                        title="Mechanic / EFZ mechanical engineering"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[applicationDevelopmentData]}
                        title="Application development"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[ictSystemeData]}
                        title="ICT Systeme, Infrastructure"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[ictNetworkData]}
                        title="ICT networks"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[nursingData]}
                        title="Nursing"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[purchasingData]}
                        title="Purchasing - Sourcing - Sales"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[processOptimizationLogisticData]}
                        title="Process optimization - logistics"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart 
                        data={[processOptimizationICTData]}
                        title="Process optimization - ICT"
                        legend={false}
                        dateFormat="month"
                    />
                    
                </ContentWithPaddingXl>
                </Container>            

        </AnimationRevealPage>
    );
}

export default OurAnalyses;
